import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">USFansSpreadsheet</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              Największy przewodnik po USFansSpreadsheet w Polsce. Porównania, rankingi i aktualne informacje 2026.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Kategorie</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Shoes</a></li>
              <li><a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Hoodies/Sweaters</a></li>
              <li><a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">T-Shirts</a></li>
              <li><a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Jackets</a></li>
              <li><a href="https://kaspreadsheet.com/category-915-Pants%2FShorts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Pants/Shorts</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Przewodnik</h4>
            <ul className="space-y-2.5">
              <li><Link to="/artykul/kompletny-przewodnik" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Kompletny przewodnik</Link></li>
              <li><a href="/#porownanie" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Porównanie</a></li>
              <li><a href="/#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="/#bezpieczenstwo" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">Bezpieczeństwo</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Informacje</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">kaspreadsheet.com</a></li>
              <li><span className="text-sm text-background-400">Ostatnia aktualizacja: 24 czerwca 2026</span></li>
              <li><span className="text-sm text-background-400">Język: Polski</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 USFansSpreadsheet Polska. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-sm text-background-500">
            Niezależny przewodnik. Nie jesteśmy powiązani z kaspreadsheet.com.
          </p>
        </div>
      </div>
    </footer>
  );
}